import { notify } from "../../components/alerts";
import {
  disableLocationsLoading,
  setCountries,
  setLocationsLoading,
  setStates,
} from "../../store/slices/locations";
import { AppDispatch } from "../../store/store";
import {
  ICountry,
  ICountriesResponse,
  IStatesResponse,
} from "../../store/@types/locations";

import { getErrorMessage } from "./apiError";
import { rootApiInstance } from "../../utils/axiosInstance";

export const get_countries = async (dispatch: AppDispatch): Promise<void> => {
  dispatch(setLocationsLoading());
  try {
    const response = await rootApiInstance.get<ICountriesResponse>(
      "/api/v1/locations/countries",
    );
    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to load countries");
    }

    const countries = response.data.data.countries.filter(
      (country: ICountry) => country.is_active,
    );

    dispatch(setCountries(countries));
  } catch (error) {
    notify({
      message: getErrorMessage(error, "Failed to load countries"),
      type: "error",
    });
  } finally {
    dispatch(disableLocationsLoading());
  }
};

export const get_states = async (
  dispatch: AppDispatch,
  countryId: string | number,
): Promise<void> => {
  dispatch(setLocationsLoading());
  try {
    const response = await rootApiInstance.get<IStatesResponse>(
      `/api/v1/locations/countries/${countryId}/states`,
    );
    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to load states");
    }
    dispatch(setStates(response.data.data.states));
  } catch (error) {
    notify({
      message: getErrorMessage(error, "Failed to load states"),
      type: "error",
    });
  } finally {
    dispatch(disableLocationsLoading());
  }
};
